import {IntlProvider} from 'react-intl';
import {connect} from 'react-redux';

const mapStateToProps = ({ locales: { locale, messages } }) => ({
  key: locale,
  locale,
  messages
});

export default connect(mapStateToProps)(IntlProvider);